import React, { useState } from 'react';
import { useContract } from '../../context/ContractContext';

const ContractTypeSelector = () => {
  const { contractData, updateContractData } = useContract();
  const [selectedArea, setSelectedArea] = useState(null);
  const [showComingSoon, setShowComingSoon] = useState(false);

  const contractAreas = [
    {
      id: 'imobiliario',
      title: 'Contratos Imobiliários',
      description: 'Locação, compra e venda, administração de imóveis e condomínios',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      ),
      contracts: [
        {
          id: 'locacao',
          title: 'Locação',
          description: 'Contratos de aluguel residencial e comercial',
          available: true
        },
        {
          id: 'compra-venda',
          title: 'Compra e Venda',
          description: 'Transferência de propriedade de imóveis',
          available: true
        },
        {
          id: 'administracao',
          title: 'Administração',
          description: 'Gestão de propriedades e condomínios',
          available: true
        }
      ]
    },
    {
      id: 'trabalhista',
      title: 'Contratos Trabalhistas',
      description: 'CLT, prestação de serviços, estágio, terceirização e consultoria',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      ),
      contracts: [
        {
          id: 'clt',
          title: 'CLT',
          description: 'Contrato de trabalho com carteira assinada',
          available: false
        },
        {
          id: 'prestacao-servicos',
          title: 'Prestação de Serviços',
          description: 'Contrato de prestação de serviços profissionais',
          available: false
        },
        {
          id: 'estagio',
          title: 'Estágio',
          description: 'Contrato de estágio supervisionado',
          available: false
        },
        {
          id: 'terceirizacao',
          title: 'Terceirização',
          description: 'Contrato de terceirização de serviços',
          available: false
        }
      ]
    },
    {
      id: 'comercial',
      title: 'Contratos Comerciais',
      description: 'Fornecimento, distribuição, parceria, franquia e representação',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      ),
      contracts: [
        {
          id: 'fornecimento',
          title: 'Fornecimento',
          description: 'Contrato de fornecimento de produtos',
          available: false
        },
        {
          id: 'distribuicao',
          title: 'Distribuição',
          description: 'Contrato de distribuição comercial',
          available: false
        },
        {
          id: 'parceria',
          title: 'Parceria',
          description: 'Contrato de parceria comercial',
          available: false
        },
        {
          id: 'franquia',
          title: 'Franquia',
          description: 'Contrato de franquia',
          available: false
        },
        {
          id: 'representacao',
          title: 'Representação Comercial',
          description: 'Contrato de representação de vendas',
          available: false
        }
      ]
    },
    {
      id: 'servicos',
      title: 'Contratos de Serviços',
      description: 'Prestação de serviços profissionais, manutenção e consultoria',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      ),
      contracts: [
        {
          id: 'consultoria',
          title: 'Consultoria',
          description: 'Contrato de consultoria profissional',
          available: false
        },
        {
          id: 'manutencao',
          title: 'Manutenção',
          description: 'Contrato de manutenção e suporte',
          available: false
        },
        {
          id: 'servicos-profissionais',
          title: 'Serviços Profissionais',
          description: 'Prestação de serviços especializados',
          available: false
        }
      ]
    },
    {
      id: 'societario',
      title: 'Contratos Societários',
      description: 'Constituição de empresa, acordo de acionistas e quotas',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
      contracts: [
        {
          id: 'constituicao-empresa',
          title: 'Constituição de Empresa',
          description: 'Contrato social e documentação',
          available: false
        },
        {
          id: 'acordo-acionistas',
          title: 'Acordo de Acionistas',
          description: 'Acordo entre sócios e acionistas',
          available: false
        },
        {
          id: 'compra-venda-quotas',
          title: 'Compra e Venda de Quotas',
          description: 'Transferência de participação societária',
          available: false
        }
      ]
    },
    {
      id: 'outros',
      title: 'Outros Contratos',
      description: 'Confidencialidade, licenciamento, empréstimo e comodato',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" />
        </svg>
      ),
      contracts: [
        {
          id: 'confidencialidade',
          title: 'Confidencialidade (NDA)',
          description: 'Acordo de não divulgação',
          available: false
        },
        {
          id: 'licenciamento',
          title: 'Licenciamento',
          description: 'Licença de uso de marca ou produto',
          available: false
        },
        {
          id: 'emprestimo',
          title: 'Empréstimo',
          description: 'Contrato de empréstimo entre partes',
          available: false
        },
        {
          id: 'comodato',
          title: 'Comodato',
          description: 'Empréstimo gratuito de bem',
          available: false
        }
      ]
    }
  ];

  const handleAreaSelection = (areaId) => {
    setSelectedArea(areaId);
  };

  const handleContractSelection = (contractId, available) => {
    if (!available) {
      setShowComingSoon(true);
      return;
    }
    updateContractData('type', contractId);
  };

  const handleBack = () => {
    setSelectedArea(null);
  };

  const ComingSoonModal = () => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-md mx-4 shadow-xl">
        <div className="text-center">
          <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
          </div>
          <h3 className="text-xl font-bold text-dark-900 mb-2">Em Construção</h3>
          <p className="text-neutral-600 mb-6">
            Este tipo de contrato está em desenvolvimento e estará disponível em breve. 
            Por enquanto, você pode utilizar os contratos imobiliários disponíveis.
          </p>
          <button
            onClick={() => setShowComingSoon(false)}
            className="px-6 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-lg font-medium transition-colors"
          >
            Entendi
          </button>
        </div>
      </div>
    </div>
  );

  if (!selectedArea) {
    return (
      <div className="space-y-6">
        <div>
          <h3 className="text-lg font-semibold text-dark-900 mb-2">
            Selecione a Área do Contrato
          </h3>
          <p className="text-neutral-600 mb-6">
            Escolha a categoria do contrato que deseja criar
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {contractAreas.map((area) => (
              <div
                key={area.id}
                onClick={() => handleAreaSelection(area.id)}
                className="cursor-pointer rounded-lg border border-neutral-200 bg-white hover:border-primary-300 hover:shadow-md transition-all duration-200 p-6 group"
              >
                <div className="flex items-start space-x-4 mb-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-colors">
                    {area.icon}
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-semibold text-dark-900 mb-2">
                      {area.title}
                    </h4>
                    <p className="text-sm text-neutral-600 leading-relaxed">
                      {area.description}
                    </p>
                  </div>
                </div>
                
                <div className="mt-4 pt-4 border-t border-neutral-200">
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-neutral-500">
                      {area.contracts.length} tipo{area.contracts.length > 1 ? 's' : ''}
                    </span>
                    <svg className="w-5 h-5 text-primary-500 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {showComingSoon && <ComingSoonModal />}
      </div>
    );
  }

  const currentArea = contractAreas.find(area => area.id === selectedArea);

  return (
    <div className="space-y-6">
      <div>
        <button
          onClick={handleBack}
          className="flex items-center text-primary-600 hover:text-primary-700 mb-6 transition-colors"
        >
          <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Voltar para áreas
        </button>

        <div className="flex items-center space-x-4 mb-6 p-4 bg-neutral-50 rounded-lg border border-neutral-200">
          <div className="w-12 h-12 bg-primary-500 rounded-lg flex items-center justify-center text-white">
            {currentArea.icon}
          </div>
          <div>
            <h3 className="text-xl font-semibold text-dark-900">
              {currentArea.title}
            </h3>
            <p className="text-neutral-600">
              Selecione o tipo de contrato
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {currentArea.contracts.map((contract) => (
            <div
              key={contract.id}
              onClick={() => handleContractSelection(contract.id, contract.available)}
              className={`
                relative cursor-pointer rounded-lg border-2 p-6 transition-all duration-200
                ${contractData.type === contract.id
                  ? 'border-primary-500 bg-primary-50 shadow-md'
                  : contract.available
                    ? 'border-neutral-200 bg-white hover:border-primary-300 hover:shadow-sm'
                    : 'border-neutral-200 bg-neutral-50 hover:border-neutral-300'
                }
              `}
            >
              {!contract.available && (
                <div className="absolute top-3 right-3">
                  <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-neutral-200 text-neutral-600">
                    Em breve
                  </span>
                </div>
              )}

              <div className="absolute top-4 right-4">
                {contract.available && (
                  <div className={`
                    w-6 h-6 rounded-full border-2 flex items-center justify-center
                    ${contractData.type === contract.id
                      ? 'border-primary-500 bg-primary-500'
                      : 'border-neutral-300 bg-white'
                    }
                  `}>
                    {contractData.type === contract.id && (
                      <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    )}
                  </div>
                )}
              </div>

              <h4 className={`
                text-lg font-semibold mb-3 pr-8
                ${contractData.type === contract.id ? 'text-primary-800' : 'text-dark-900'}
              `}>
                {contract.title}
              </h4>

              <p className={`
                text-sm leading-relaxed
                ${contractData.type === contract.id ? 'text-primary-700' : 'text-neutral-600'}
              `}>
                {contract.description}
              </p>

              {contractData.type === contract.id && contract.available && (
                <div className="mt-4 text-center">
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-800">
                    <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    Selecionado
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>

        {contractData.type && (
          <div className="mt-6 p-4 bg-success-50 rounded-lg border border-success-200">
            <div className="flex items-center">
              <svg className="w-5 h-5 text-success-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="text-success-800 font-medium">
                Tipo de contrato selecionado com sucesso!
              </span>
            </div>
            <p className="text-success-700 text-sm mt-1">
              Continue para preencher as informações necessárias.
            </p>
          </div>
        )}
      </div>

      {showComingSoon && <ComingSoonModal />}
    </div>
  );
};

export default ContractTypeSelector;